import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { SlotGameType1 } from "../SlotGameType1";

export class LuckyIce100 extends SlotGameType1 {

	//protected override panelFactory: IPanelFactory = new LuckyIce100PanelFactory();
	protected override helpFactory: IHelpFactory = new LuckyIce100HelpFactory();

	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "#0A7CBF",
            coloroutherStroke: "black",
            colorinnerStroke: "#031333",
		}

	//LED COLOR
	protected override ColorLed: string = "250,0,0\n";


	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "LuckyIce100");
		this.spinnableReelsParams.topBorderWidth = 21;
		this.spinnableReelsParams.bottomBorderWidth = 13;
	}
}

//Panel Colorized
class LuckyIce100PanelFactory implements IPanelFactory {
	public CreateNewPanel(params: PanelParams): Panel {
		return new LuckyIce100Panel(params);
	}
}

class LuckyIce100Panel extends Panel {
	protected override ButtonBackground(): ButtonColors {
		let color: ButtonColors = {
			backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
		};
		return color;

	}

}

class LuckyIce100HelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new LuckyIce100Help(params);
	}
}

class LuckyIce100Help extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
		return color;
	}
}